<section class="ftco-section p-5 d-flex flex-column">
    <a href="/"><img [src]="logo" alt="logo" style="width: 100px;"/></a>
    <div class="d-flex justify-content-center align-items-center w-100 h-100">
        <div class="text-center p-5 m-5 w-50 d-none d-md-block">
            <h4>Study</h4>
            <h4 [style]="style.color">Practice</h4>
            <h4>Succeed</h4>
        </div>
        <div class="w-100 w-md-50 row">
            <div class="col-md-3"></div>
            <div class="bg-light m-5 p-5 mx-auto rounded col-md-6">
                <h5 class="mb-4">Sign In</h5>
                <p>Don't have an account? <a href="/register" [style]="style.color">Sign Up</a></p>           
    
                <!-- <div class="w-100 mb-2">
                    <app-googleauth></app-googleauth>
                </div> -->
                <form [formGroup]="loginForm" (ngSubmit)="login()" class="signin-form">
                    <div class="form-group mb-3">
                        <label class="label text-dark" for="Email">Email</label>
                        <input type="text" class="form-control" placeholder="Email" formControlName="email" required>
                    </div>
                    <div class="form-group mb-3">
                        <label class="label text-dark" for="password">Password</label>
                        <input type="password" class="form-control" placeholder="Password" formControlName="password"
                            required>
                    </div>
                    <div class="form-group">
                        <button type="submit" [style]="style.btnstyle" class="submit px-3 w-100"
                            [disabled]="loginForm.invalid || loading">
                            <i class="fa fa-spinner spin-icon spinner" style="font-size: large ;" *ngIf="loading"></i>Log In</button>
                    </div>
                    <div class="form-group d-md-flex">
                        <div class="w-50 text-left">
                        </div>
                        <div class="w-50 text-md-right">
                            <a href="/forgotpassword">Forgot Password?</a>
                        </div>
                    </div>
                </form>
            </div>
            <div class="col-md-3"></div>
        </div>        
    </div>
</section>